import * as Yup from "yup";

export const workCenterValidation = Yup.object().shape({
  name: Yup.string().required("กรุณาระบุโรงงาน"),
  description: Yup.string().required("กรุณาระบุคำอธิบาย"),
});
